import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import classNames from 'classnames';
import RegularXmarkIcon from '@/components/icons/regular/xmark';
import AeropostaleLogo from '@/public/images/employers/aeropostale.svg';
import Forever21Logo from '@/public/images/employers/forever21.svg';
import JCPenneyLogo from '@/public/images/employers/jcpenney.svg';
import ReebokLogo from '@/public/images/employers/reebok.svg';
import styles from './FormattedBrandLogo.module.scss';

// The partner files, by the name utils/employers.json gives as `logo`: static
// imports, so next/image knows each file's size (Phase 5 PR 5.10, when the
// legacy components/Image.js and its `EmployerImage` retired).
const EMPLOYER_LOGOS = {
  'aeropostale.svg': AeropostaleLogo,
  'forever21.svg': Forever21Logo,
  'jcpenney.svg': JCPenneyLogo,
  'reebok.svg': ReebokLogo
};

/**
 * The application's wordmark, and an employer partner's logo after an "×"
 * (Phase 5 PR 5.1: a page module; the separator is the regular/xmark page
 * icon). `align="center"` above a step, `"start"` on the returning
 * applicant's and the submitted screens. The links keep their text and
 * href; the wordmark draws over it. The partner's logo is its file at its own
 * size, at most the slot's width, unoptimised (SVG), as the legacy intrinsic
 * image drew it.
 */
export function FormattedBrandLogo(t0) {
  const $ = _c(9);
  const {
    site,
    employer,
    align: t1
  } = t0;
  const align = t1 === undefined ? "center" : t1;
  const partnerLogo = employer ? EMPLOYER_LOGOS[employer.logo] : undefined;
  const t2 = styles[`brand--${align}`];
  let t3;
  if ($[0] !== t2) {
    t3 = classNames(styles.brand, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== employer || $[3] !== partnerLogo || $[4] !== site) {
    t4 = site === "sacramento" ? <Link href="/" className={classNames(styles.wordmark, styles["wordmark--sacramento"])}>Campus Sacramento</Link> : <><Link href="/" className={styles.wordmark}>Campus</Link>{employer && <><RegularXmarkIcon className={styles.separator} /><div className={styles.partner}>{partnerLogo && <Image alt={`${employer.name} logo`} className={styles["partner-logo"]} priority={true} sizes="140px" src={partnerLogo} unoptimized={true} />}</div></>}</>;
    $[2] = employer;
    $[3] = partnerLogo;
    $[4] = site;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}